import {
  type TableColumnFormatNeighborIp,
  getValueFromKeyOfType,
} from '@ipfabric/utils';
import { nullable } from '@ipfabric/utils/fp/nullable';
import type { RenderedTableCell } from 'components/Table/cells/RenderedTableCell';
import { pipe } from 'fp-ts/lib/function';
import type { RenderCellContentArguments } from '../model/TableCellContentRenderFunction';
import { wrapNeighborIpWithLink } from './helpers/neighborIpWrapWithLink';

export const renderNeighborIpCell = <TRow,>(
  format: TableColumnFormatNeighborIp<TRow>,
  { row, severity }: RenderCellContentArguments<TRow>,
): RenderedTableCell => {
  const value = getValueFromKeyOfType(row, format.field);
  const protocol = getValueFromKeyOfType(row, format.protocolField);

  const content = pipe(
    value,
    nullable.chain(
      (v) => wrapNeighborIpWithLink(v, protocol, row, severity !== null) ?? v,
    ),
  );

  return {
    content,
  };
};
